import { estadoDoPainel, type Me } from '@/features/auth/sessao';
import { pode, type Permissao } from './matriz';
import { TELA_DE_TODOS, telaDoCodigo, type CodigoDaTela, type Modulo } from './telas';

export interface Permissoes {
  /** A tela está liberada para a função do usuário na empresa ativa (`telasPermitidas`)? */
  podeVerTela: (codigo: CodigoDaTela) => boolean;
  /** O papel na empresa ativa permite a ação (matriz do backend)? */
  pode: (permissao: Permissao) => boolean;
  /** O módulo está ligado na empresa ativa (`modulos` do `/me`, spec 022)? */
  moduloAtivo: (modulo: Modulo) => boolean;
  superAdmin: boolean;
}

/**
 * Permissões de quem está logado, a partir do `/me` (RN-011). Só escondem menus e botões: quem
 * autoriza é a API, que responde 403 a qualquer tentativa (constituição III.3).
 */
export function permissoesDe(me: Me | undefined): Permissoes {
  const telas = new Set(me?.telasPermitidas);
  return {
    podeVerTela: (codigo) =>
      me !== undefined &&
      estadoDoPainel(me) === 'painel' &&
      (codigo === TELA_DE_TODOS || telas.has(codigo)) &&
      permitidaPeloPapel(me, codigo),
    pode: (permissao) => pode(me?.papel, permissao),
    moduloAtivo: (modulo) => me?.modulos[modulo] === true,
    superAdmin: me?.superAdmin === true,
  };
}

function permitidaPeloPapel(me: Me, codigo: CodigoDaTela): boolean {
  const tela = telaDoCodigo(codigo);
  const permissao = tela !== undefined && 'permissao' in tela ? tela.permissao : undefined;
  return permissao === undefined || pode(me.papel, permissao);
}
